export default {"src":"/_next/static/media/symbol-icon-letter.adb5d7cb.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};